import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	handle_compressed_image_upload,

} from '../../../Utils';
import Hosts from '../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);

	//const [disabled, set_disabled] = useState(true)


	const [teste_imagem, set_teste_imagem] = useState('')

	const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

        set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {
				set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
				setLoading(false)
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					
					files_image.forEach(async (el_image) => {
						if (el_image !== null) {
							if (el_image.files.length > 0) {
								await uploadFilesImage(el_image.files)
							} else {
								dados.current.info['media'] = 
								{
									id: '1',
									link: el_image.link,
									name: el_image.link
								}
							}
						}
					})
					set_files_image([])

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0 || dados.current.info.language[langid] === undefined || dados.current.info.language[langid] === null) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', category: '', observation: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)

		console.log('name', name)
		console.log('value', value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_detail = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info.detail[name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSingleCheckEquimanentos = e => {
		const { name } = e.target;

		if(dados.current.info.detail[name] === undefined)
			dados.current.info.detail[name] = false
		
		set_dados(dados.current.info.detail[name] = !dados.current.info.detail[name])
	}

	const handleSingleCheckVisivel = e => {
		//const { name } = e.target;

		if(dados.current.info['status'] === undefined)
			dados.current.info['status'] = false
		
		set_dados(dados.current.info['status'] = !dados.current.info['status'])
	}

	const handle_change_info_forfait = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info.forfait[name] = value)

		if(name === 'code_taxe') {

			set_dados(dados.current.info.forfait['taxe'] = parseFloat(value).toFixed(2))

			let price_s_vat_aux = (parseFloat(dados.current.info.forfait['price']) / (1 + parseFloat(dados.current.info.forfait['taxe']) * 0.01)) 
			set_dados(dados.current.info.forfait['price_s_vat'] = parseFloat(price_s_vat_aux).toFixed(5))

			console.log('dados.current.info.forfait', dados.current.info.forfait)

		}
		else if(name === 'price') {

			let price_s_vat_aux = (parseFloat(dados.current.info.forfait['price']) / (1 + parseFloat(dados.current.info.forfait['taxe']) * 0.01)) 
			set_dados(dados.current.info.forfait['price_s_vat'] = parseFloat(price_s_vat_aux).toFixed(5))

			console.log('dados.current.info.forfait', dados.current.info.forfait)

		}
		else if(name === 'price_s_vat') {

			let price_aux = (parseFloat(dados.current.info.forfait['price_s_vat']) * (1 + parseFloat(dados.current.info.forfait['taxe']) * 0.01)) 
			set_dados(dados.current.info.forfait['price'] = parseFloat(price_aux).toFixed(2))

			console.log('dados.current.info.forfait', dados.current.info.forfait)
		}
		else {

			set_dados(dados.current.info.forfait[name] = value)

		}
	}

	const handle_change_info_pista = (e) => {
		const { name, value } = e.target;

		dados.current.info.pista['id'] = '90'
		set_dados(dados.current.info.pista[name] = value)

		if(name === 'code_taxe') {

			set_dados(dados.current.info.pista['taxe'] = parseFloat(value).toFixed(2))

			let price_s_vat_aux = (parseFloat(dados.current.info.pista['price']) / (1 + parseFloat(dados.current.info.pista['taxe']) / 100)) 
			set_dados(dados.current.info.pista['price_s_vat'] = parseFloat(price_s_vat_aux).toFixed(5))

			console.log('dados.current.info.pista', dados.current.info.pista)

		}
		else if(name === 'price') {

			let price_s_vat_aux = (parseFloat(dados.current.info.pista['price']) / (1 + parseFloat(dados.current.info.pista['taxe']) / 100)) 
			set_dados(dados.current.info.pista['price_s_vat'] = parseFloat(price_s_vat_aux).toFixed(5))

			console.log('dados.current.info.pista', dados.current.info.pista)

		}
		else if(name === 'price_s_vat') {

			let price_aux = (parseFloat(dados.current.info.pista['price_s_vat']) * (1 + parseFloat(dados.current.info.pista['taxe']) / 100)) 
			set_dados(dados.current.info.pista['price'] = parseFloat(price_aux).toFixed(2))

			console.log('dados.current.info.pista', dados.current.info.pista)
		}
		else {
			dados.current.info.pista[name] = value
		}

	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {

		console.log('handle_change_info_ckeditor', value);

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_value_info_lang = (order, langid, name) => {
		if (dados.current.info['language'] !== undefined && dados.current.info['language'] !== null) {
			if (dados.current.info['language'][langid] !== undefined && dados.current.info['language'][langid] !== null) {
				return dados.current.info['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files } = e.target;

		if(dados.current.info['media'] === undefined)
			dados.current.info['media'] = { id: '', link: '', name: '' }

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v, k) => {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(v);
				let files_img_aux = image_base64

				if (files_img_aux === undefined)
					files_img_aux = []

				files_img_aux.push({ id: '1', name: v.name.split('.')[0] + '.webp', link: base64 })

				set_image_base64(files_img_aux)

				console.log('image_base64', image_base64)
				if (filesArray.length === (k + 1)) {
					set_dados(dados.current,)
					setRefresh(refresh + 1)
				}
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_image
		files_aux.push({ files: storedFiles })
		set_files_image(files_aux)

	}

	const uploadFilesImage = (files) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'store')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				dados.current.info['media'] = {
					id: i,
					link: res.data.path + '/' + res.data.name,
					name: file.name,
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const convertImgToBase64URL = (url, callback, outputFormat) => {

		console.log('convertImgToBase64URL url', url)
		var img = new Image();
		img.crossOrigin = 'Anonymous';
		img.onload = function(){
			// var canvas = document.createElement('CANVAS'),
			// ctx = canvas.getContext('2d'), dataURL;
			// canvas.height = img.height;
			// canvas.width = img.width;
			// ctx.drawImage(img, 0, 0);
			// dataURL = canvas.toDataURL(outputFormat);
			// callback(dataURL);
			// canvas = null; 
		};
		img.src = url;
	}

	const click_test = (url) => {

		console.log('url', url)
		//convertImgToBase64URL('http://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png', function(base64Img){
		convertImgToBase64URL(url, function(base64Img) {
			console.log('base64Img', base64Img)
			set_teste_imagem(base64Img)
			//alert('it works');
				//$('.output').find('img').attr('src', base64Img);  
		})
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
													:
														null
												}
											</ul>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																	<div className="row mb-5">
																		<div className="col-md-3">
																			<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="name" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.name : get_value_info_lang('0', el_lang.id, 'name')} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required={el_lang.id === '1' ? 'required' : ''} />
																		</div>

																		<div className="col-md-3">
																			<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_category} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="category" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.category : get_value_info_lang('0', el_lang.id, 'category')} className="form-control" placeholder={language[lang].field_category_placeholder} onChange={handle_change_info} required={el_lang.id === '1' ? 'required' : ''} />
																		</div>

																		<div className="col-md-6">
																			<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_observation} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="text" name="observation" data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? dados.current.info.observation : get_value_info_lang('0', el_lang.id, 'observation')} className="form-control" placeholder={language[lang].field_observation_placeholder} onChange={handle_change_info} />
																		</div>
																	</div>

																	<div className="row mb-5">
																		<div className="col-md-3">
																			<div className="mb-3">
																				<label className="col-form-label required fw-bold fs-6">{language[lang].field_tipologia}</label>

																				<select className="form-select rounded-0" aria-label="Select Type" name='tipologia' value={dados.current.info.detail.tipologia !== undefined ? dados.current.info.detail.tipologia : '0'} onChange={handle_change_info_detail}>
																					<option value="">Escolher Tipologia</option>
																					<option value="0">Adulto</option>
																					<option value="1">Criança</option>
																					<option value="2">Familia</option>
																				</select>
																			</div>
																		</div>
																		<div className="col-md-3">
																			<div className="mb-3">
																				<label className="col-form-label required fw-bold fs-6">{language[lang].field_tipo}</label>

																				<select className="form-select rounded-0" aria-label="Select Type" name='tipo' value={dados.current.info.detail.tipo} onChange={handle_change_info_detail}>
																					<option value="">Escolher Tipo</option>
																					<option value="-1">Entrada</option>
																					<option value="0">Entrada Simples sem Equipamentos</option>
																					<option value="1">Entrada Simples com Equipamentos</option>
																					<option value="2">Entrada Grupo sem Equipamentos</option>
																					<option value="3">Entrada Grupo com Equipamentos</option>
																					<option value="4">Aula sem Equipamento com Entrada</option>
																					<option value="5">Aula com Equipamento com Entrada</option>
																					<option value="6">Aula sem Equipamento sem Entrada</option>
																					<option value="7">Aula com Equipamento sem Entrada</option>
																					<option value="8">Experiência</option>
																					<option value="9">Equipamento</option>
																				</select>
																			</div>
																		</div>
																		<div className="col-md-3"> 
																			<div className="mb-3">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_equipamentos}</label>
																				<div className="input-group">
																					<label className="switch">
																						<input
																							id={'item-switch'}
																							name={"equipamentos"}
																							className=""
																							type="checkbox"
																							value={dados.current.info.detail['equipamentos']}
																							onChange={handleSingleCheckEquimanentos}
																							defaultChecked={dados.current.info.detail.equipamentos}
																						/>
																						<span className="slider round" htmlFor={'item-switch'}></span>
																					</label>
																				</div>
																			</div>
																		</div>

																		<div className="col-md-3"> 
																			<div className="mb-3">
																				<label className="fs-6 fw-bold mb-2">{language[lang].field_visivel}</label>
																				<div className="input-group">
																					<label className="switch">
																						<input
																							id={'item-switch-v'}
																							name={"status"}
																							className=""
																							type="checkbox"
																							value={dados.current.info['status']}
																							onChange={handleSingleCheckVisivel}
																							defaultChecked={dados.current.info['status']}
																						/>
																						<span className="slider round" htmlFor={'item-switch-v'}></span>
																					</label>
																				</div>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-5">
																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_adultos} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="number" min="0" name="adultos" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.detail.adultos} className="form-control text-end" placeholder={language[lang].field_adultos_placeholder} onChange={handle_change_info_detail} required='required' />
																		</div>

																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_criancas} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="number" min="0" name="criancas" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.detail.criancas} className="form-control text-end" placeholder={language[lang].field_criancas_placeholder} onChange={handle_change_info_detail} required='required' />
																		</div>

																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_pessoas} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="number" min="0" name="pessoas" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.detail.pessoas} className="form-control text-end" placeholder={language[lang].field_pessoas_placeholder} onChange={handle_change_info_detail} required='required' />
																		</div>

																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_dias} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																			<input type="number" min="0" name="dias" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.detail.dias} className="form-control text-end" placeholder={language[lang].field_dias_placeholder} onChange={handle_change_info_detail} required='required' />
																		</div>
																	</div>

																	<div className="row mb-5">
																		<div className="col-md-12">
																			<div className="row">
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_forfait_price} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<div className="input-group">
																						<input type="number" min="0" step="any" name="price" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.forfait.price} className="form-control text-end" placeholder={language[lang].field_forfait_price_placeholder} onChange={handle_change_info_forfait} required='required' />
																						<span className='input-group-text'>€</span>
																					</div>
																				</div>
																				
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_forfait_taxe} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<select className="form-select rounded-0" aria-label="Select Type" name='code_taxe' value={dados.current.info.forfait['code_taxe'] !== undefined ? dados.current.info.forfait['code_taxe'] : '00'} onChange={handle_change_info_forfait}>
																						<option value="">Escolher IVA</option>
																						<option value="00" data-code="00" data-taxe="0.00">0%</option>
																						<option value="06" data-code="06" data-taxe="6.00">6%</option>
																						<option value="13" data-code="13" data-taxe="13.00">13%</option>
																						<option value="23" data-code="23" data-taxe="23.00">23%</option>
																					</select>
																				</div>
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_forfait_price_s_vat} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<div className="input-group">
																						<input type="number" min="0" step="any" name="price_s_vat" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.forfait !== undefined && dados.current.info.forfait['price_s_vat'] !== undefined ? dados.current.info.forfait['price_s_vat'] : dados.current.info.forfait['price']} className="form-control text-end" placeholder={language[lang].field_forfait_price_s_vat_placeholder} onChange={handle_change_info_forfait} required='required' />
																						<span className='input-group-text'>€</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-5">
																		<div className="col-md-12">
																			<div className="row">
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_pista_price} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<div className="input-group">
																						<input type="number" min="0" step="any" name="price" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.pista.price} className="form-control text-end" placeholder={language[lang].field_pista_price_placeholder} onChange={handle_change_info_pista} required='required' />
																						<span className='input-group-text'>€</span>
																					</div>
																				</div>
																				
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_pista_taxe} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<select className="form-select rounded-0" aria-label="Select Type" name='code_taxe' value={dados.current.info.pista['code_taxe'] !== undefined ? dados.current.info.pista['code_taxe'] : '00'} onChange={handle_change_info_pista}>
																						<option value="">Escolher IVA</option>
																						<option value="00" data-code="00" data-taxe="0.00">0%</option>
																						<option value="06" data-code="06" data-taxe="6.00">6%</option>
																						<option value="13" data-code="13" data-taxe="13.00">13%</option>
																						<option value="23" data-code="23" data-taxe="23.00">23%</option>
																					</select>
																				</div>
																				<div className="col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_pista_price_s_vat} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																					<div className="input-group">
																						<input type="number" min="0" step="any" name="price_s_vat" data-langid={el_lang.id} data-lang={el_lang.code} value={dados.current.info.pista !== undefined && dados.current.info.pista['price_s_vat'] !== undefined ? dados.current.info.pista['price_s_vat'] : dados.current.info.pista['price']} className="form-control text-end" placeholder={language[lang].field_pista_price_s_vat_placeholder} onChange={handle_change_info_pista} required='required' />
																						<span className='input-group-text'>€</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>

																	<div className="row mb-5">
																		<div className="col-md-9">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																			<AssecCKEditor
																				name={"text"}
																				content={el_lang.id === '1' ? dados.current.info.description : get_value_info_lang('0', el_lang.id, 'description')}
																				func={(e) => handle_change_content_ckeditor(e, '0', el_lang.id, el_lang.code, 'description')}
																			/>

																			<textarea className="form-control d-none" type="description" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																		</div>
																		<div className="col-3">
																			<div className="div-image">
																				<label className="col-form-label fw-bold fs-6">{language[lang].image}</label>

																				<div className="dropzone-panel mb-2">
																					<div className="div-form-input col-12 custom-file">
																						<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-info"}>{language[lang].image_choose}</label>
																						<input
																							id={"input-files-info"}
																							type="file"
																							accept="image/*"
																							data-type={'image'}
																							className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																							onChange={onChangeHandlerFilesImage}
																							multiple
																						/>
																					</div>
																				</div>




																				<span 
																					className="btn btn-sm btn-secondary rounded-0 multi-item me-1"
																					onClick={() => click_test(dados.current.info.media['link'])}
																				>
																					click
																				</span>

																				<div className="row">
																					{
																					image_base64.length > 0 ?
																						<div className="col-12">
																							<img className='img-fluid' src={image_base64[0]['link'] !== undefined ? image_base64[0]['link'] : ''} alt="" />
																						</div>
																					:
																						<div className="col-12">
																							<img className='img-fluid' src={dados.current.info['media'] !== undefined ? dados.current.info.media['link'] : ''} alt="" />
																						</div>
																					}



																					<div className="col-12">
																						<img className='img-fluid' src={teste_imagem} alt="" />
																					</div>
																				</div>
																			</div>
																		</div>
																		
																		
																	</div>
																</div>
															)
														})
													:
														<div className={"tab-pane show active"} role="tabpanel">
															<div className="row mb-6">
																<div className="col-md-8">
																	<label className="fs-6 required fw-bold mb-2">{language[lang].field_name}</label>
																	<input type="text" name="name" data-langid={'1'} data-lang={'pt'} value={dados.current.info.name} className="form-control" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_abreviation}</label>
																	<input type="text" name="abreviation" data-langid={'1'} data-lang={'pt'} value={dados.current.info.abreviation} className="form-control" placeholder={language[lang].field_abreviation_placeholder} onChange={handle_change_info} />
																</div>
															</div>

															<div className="row mb-6">
																<div className="col-md-12">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_description}</label>

																	<AssecCKEditor
																		name={"text"}
																		content={dados.current.info.description}
																		func={(e) => handle_change_content_ckeditor(e, '0', '1', 'pt', 'description')}
																	/>

																	<textarea className="form-control d-none" type="description" name="description" value={dados.current.info.description} placeholder={language[lang].field_description_placeholder} onChange={handle_change_info} />
																</div>
															</div>
														</div>
													}
												</div>
											</div>
										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
